import { useMutation } from '@apollo/client';
import type { Language } from '@application/types';
import { graphql } from '@gql/gql';
import type {
  AccountUpdateAccountLanuageMutation,
  AccountUpdateAccountLanuageMutationVariables,
} from '@gql/graphql';
import { useCallback } from 'react';
import { useCurrentAccount } from './useCurrentAccount';

export const ACCOUNT_UPDATE_ACCOUNT_LANGUAGE = graphql(`
  mutation AccountUpdateAccountLanuage($data: AccountUpdateInput!) {
    accountMeUpdate(data: $data) {
      ...CurrentAccountInfo
    }
  }
`);

export const useUpdateAccountLanguage = () => {
  const { currentAccount } = useCurrentAccount();

  const [update, { loading, error }] = useMutation<
    AccountUpdateAccountLanuageMutation,
    AccountUpdateAccountLanuageMutationVariables
  >(ACCOUNT_UPDATE_ACCOUNT_LANGUAGE);

  const updateAccountLanguage = useCallback(
    async (newLanguage: Language) => {
      if (!currentAccount?.id) return;
      return update({
        variables: {
          data: { language: { set: newLanguage } },
        },
      });
    },
    [currentAccount?.id, update],
  );

  return {
    updateAccountLanguage,
    updateAccountLanguageLoading: loading,
    updateAccountLanguageError: error,
  };
};
